"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _themeUi = require("theme-ui");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ButtonTabGroup = function ButtonTabGroup(_ref) {
  var activeTabId = _ref.activeTabId,
      variant = _ref.variant,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["activeTabId", "variant", "children"]);

  var _useState = (0, _react.useState)(false),
      indicatorXDelta = _useState[0],
      setIndicatorXDelta = _useState[1];

  var _useState2 = (0, _react.useState)(false),
      indicatorWidthDelta = _useState2[0],
      setIndicatorWidthDelta = _useState2[1];

  var _useState3 = (0, _react.useState)(true),
      animateIndicator = _useState3[0],
      setAnimateIndicator = _useState3[1];

  var tabContainerRef = (0, _react.useRef)();
  var previousSelectedIndex = (0, _react.useRef)(activeTabId);
  (0, _react.useLayoutEffect)(function () {
    if (!tabContainerRef.current || activeTabId === -1 || previousSelectedIndex.current === -1) {
      previousSelectedIndex.current = activeTabId;
      return;
    }

    setAnimateIndicator(false);
    requestAnimationFrame(function () {
      var first = tabContainerRef.current.children[_react["default"].Children.toArray(children).findIndex(function (child) {
        return child.props.id === previousSelectedIndex.current;
      })].getBoundingClientRect();

      var last = tabContainerRef.current.children[_react["default"].Children.toArray(children).findIndex(function (child) {
        return child.props.id === activeTabId;
      })].getBoundingClientRect();

      setIndicatorXDelta(first.left - last.left);
      setIndicatorWidthDelta(first.width / last.width);
      requestAnimationFrame(function () {
        setIndicatorXDelta(null);
        setIndicatorWidthDelta(null);
        setAnimateIndicator(true);
        previousSelectedIndex.current = activeTabId;
      });
    });
  }, [activeTabId, children]);
  return (0, _themeUi.jsx)(_themeUi.Flex, _extends({}, props, {
    ref: tabContainerRef
  }), _react["default"].Children.map(children, function (child) {
    return (0, _themeUi.jsx)(_themeUi.Flex, {
      className: "Tab",
      sx: {
        position: 'relative',
        justifyContent: 'center',
        flex: '1 1 100%'
      },
      key: child.props.id
    }, child, (0, _themeUi.jsx)("span", {
      sx: {
        display: 'flex',
        position: 'absolute',
        top: 0,
        left: 0,
        justifyContent: 'center',
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
        zIndex: 1
      }
    }, (0, _themeUi.jsx)("span", {
      sx: {
        width: '100%',
        alignSelf: 'flex-end',
        opacity: child.props.id === activeTabId && animateIndicator || child.props.id === previousSelectedIndex.current && !animateIndicator ? 1 : 0,
        height: '2px',
        bg: variant === 'primary' ? 'primary' : 'secondary',
        transition: function transition(theme) {
          return animateIndicator ? "200ms transform " + theme.easing.slowToQuickToSlow : '';
        },
        transformOrigin: 'left',
        transform: child.props.id === activeTabId && !animateIndicator ? "translateX(" + indicatorXDelta + "px) scaleX(" + indicatorWidthDelta + ")" : ''
      }
    })));
  }));
};

ButtonTabGroup.propTypes = {
  children: _propTypes["default"].node.isRequired,
  activeTabId: _propTypes["default"].string,
  variant: _propTypes["default"].oneOf(['primary', 'secondary'])
};
ButtonTabGroup.defaultProps = {
  activeTabId: null,
  variant: 'primary'
};
var _default = ButtonTabGroup;
exports["default"] = _default;